var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLookoutLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 135,
    viewBox: "0 0 288 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225.4 133.9C224.9 134.1 224.3 134.2 223.7 134.4C222.7 134.6 221.6 134.7 220.5 134.7C216.9 134.7 214.2 133.8 212.6 131.9C211 130 210.2 127.2 210.2 123.4L210.3 90.5H216.2V100.9H225.4V106.5H216.2V122.7C216.2 125.2 216.7 127 217.6 128C218.5 129 219.9 129.5 221.8 129.5C222.7 129.5 223.5 129.4 224.2 129.2C224.6 129.1 225 129 225.4 128.9V133.9Z",
    fill: "#1E3239"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2 117.1C27.2 107.3 33.6 99.5 44.4 99.5C55.3 99.5 61.4 107.3 61.4 117.1C61.4 126.9 55.2 134.7 44.3 134.7C33.2 134.7 27.2 127.1 27.2 117.1ZM55.5 117.1C55.5 109.6 51.8 104.4 44.4 104.4C37.1 104.4 33.2 109.8 33.2 117.1C33.2 124.6 36.8 129.7 44.3 129.7C51.8 129.7 55.5 124.5 55.5 117.1Z",
    fill: "#1E3239"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9 117.1C64.9 107.3 71.3 99.5 82.1 99.5C93 99.5 99.1 107.3 99.1 117.1C99.1 126.9 92.9 134.7 82 134.7C70.9 134.7 64.9 127.1 64.9 117.1ZM93.1 117.1C93.1 109.6 89.4 104.4 82 104.4C74.7 104.4 70.8 109.8 70.8 117.1C70.8 124.6 74.4 129.7 81.9 129.7C89.5 129.7 93.1 124.5 93.1 117.1Z",
    fill: "#1E3239"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.8 117.1C132.8 107.3 139.2 99.5 150 99.5C160.9 99.5 167 107.3 167 117.1C167 126.9 160.8 134.7 149.9 134.7C138.8 134.7 132.8 127.1 132.8 117.1ZM161.1 117.1C161.1 109.6 157.4 104.4 150 104.4C142.7 104.4 138.8 109.8 138.8 117.1C138.8 124.6 142.4 129.7 149.9 129.7C157.4 129.7 161.1 124.5 161.1 117.1Z",
    fill: "#1E3239"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M203.7 133.9H197.6V125C195.3 131.3 190.7 134.6 184.9 134.6C176 134.6 172 128.7 172 119.9L171.9 100.8H178L178.1 118.3C178.1 124.9 180.3 129.5 187.2 129.5C193.2 129.5 197.5 124.6 197.5 115.6V100.8H203.6L203.7 133.9Z",
    fill: "#1E3239"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.9 117.3L134.4 100.9H126.6C126.6 100.9 112.9 116 110.2 118.8L110 90.7H103.9V133.9H110V130.3C110 125.6 112.8 123.9 114.9 121.5C116.6 123.5 118.8 126 118.8 126L125.7 133.9H133.9L118.9 117.3Z",
    fill: "#1E3239"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 90.6H0V134H26.1V128.1H6.4V90.6Z",
    fill: "#1E3239"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M247.6 130.3C247.6 132.8 245.6 134.7 243.2 134.7C240.8 134.7 238.8 132.7 238.8 130.3C238.8 127.8 240.8 125.9 243.2 125.9C245.6 125.8 247.6 127.8 247.6 130.3ZM246.8 130.3C246.8 128.3 245.1 126.6 243.1 126.6C241.1 126.6 239.4 128.3 239.4 130.3C239.4 132.3 241.1 134 243.1 134C245.1 134 246.8 132.3 246.8 130.3ZM243.9 130.6L244.9 132.4H244L243.1 130.7H242.5V132.4H241.7V128.1H243.3C244.1 128.1 244.6 128.6 244.6 129.4C244.7 130 244.3 130.4 243.9 130.6ZM242.5 130.1H243.2C243.6 130.1 243.9 129.8 243.9 129.4C243.9 129 243.7 128.8 243.2 128.8H242.5V130.1Z",
    fill: "#1E3239"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M243.9 50.6C243.9 50.2 243.9 49.9 243.9 49.5V10.3C243.9 10.2 243.9 10.2 243.9 10.1V0C243.8 0 243.6 0 243.5 0C242.9 0 242.3 0 241.8 0V25.4L244 50.7V51.2C243.9 51.1 243.9 50.9 243.9 50.6Z",
    fill: "#00C55F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M243.9 77.5L243.7 73.9H241.8V99.1C242.4 99.1 242.9 99.1 243.5 99.1C243.7 99.1 243.8 99.1 244 99.1L243.9 77.5Z",
    fill: "#00C55F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M243.9 50.8L241.7 25.5L239.5 0.200012C238.8 0.300012 238.1 0.300013 237.3 0.400013L239.5 26L243.9 51.3V50.8Z",
    fill: "#0DC959"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M246 77.5L245.5 73.9H243.6L243.8 77.5L245.2 99.1C245.9 99.1 246.7 99 247.4 99L246 77.5Z",
    fill: "#0DC959"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M243.9 51.3L239.5 26L235.1 0.799988C234.4 0.899988 233.7 1.09999 233 1.19999L238 29.8L244 52.1C243.9 51.8 243.9 51.5 243.9 51.3Z",
    fill: "#1BCD52"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M248.1 76.3L247.6 74H245.6L246.1 77.6L249 98.9C249.7 98.8 250.4 98.7 251.2 98.6L248.1 76.3Z",
    fill: "#1BCD52"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M250.4 76.6L249.6 74H247.6L248.1 76.3L253 98.3C253.7 98.2 254.4 98 255.1 97.8L250.4 76.6Z",
    fill: "#28D14C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M244 52L238 29.7L230.4 1.70001C229.7 1.90001 229 2.10001 228.3 2.30001L236.9 34.1L244.2 53.3C244.1 53 244 52.5 244 52Z",
    fill: "#28D14C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M244.2 53.5L236.9 34.2L225.3 3.40002C224.6 3.70002 224 3.90002 223.3 4.20002L236.4 39L244.6 55.2C244.4 54.7 244.3 54.1 244.2 53.5Z",
    fill: "#36D446"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M252.9 77.2L251.5 73.9H249.5L250.3 76.5L257 97.2C257.7 97 258.4 96.8 259.1 96.6L252.9 77.2Z",
    fill: "#36D446"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M244.6 55.2L236.4 39L219.8 6C219.2 6.3 218.5 6.7 217.9 7.1L235.4 41.8L245.1 56.8C244.9 56.3 244.7 55.8 244.6 55.2Z",
    fill: "#43D83F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M255.2 77.1L253.5 74H251.5L252.9 77.3L260.8 96.1C261.5 95.8 262.2 95.6 262.8 95.3L255.2 77.1Z",
    fill: "#43D83F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M245.1 56.8L235.4 41.8L214.4 9.29999C213.8 9.69999 213.2 10.2 212.7 10.6L237.4 49L246.2 59.4C245.7 58.6 245.4 57.7 245.1 56.8Z",
    fill: "#50DC39"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M257.6 76.9L255.4 73.9H253.4L255.1 77L264.6 94.3C265.3 94 265.9 93.7 266.5 93.3L257.6 76.9Z",
    fill: "#50DC39"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M260.5 77.3L257.4 74H255.4L257.6 77L268.6 92.3C269.2 91.9 269.8 91.5 270.5 91.1L260.5 77.3Z",
    fill: "#5EE033"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M246.1 59.4L237.4 49L208.5 14.5C208 15 207.5 15.5 207 16.1L236.9 51.7L247.4 61.5C246.9 60.8 246.5 60.1 246.1 59.4Z",
    fill: "#5EE033"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M264.1 77.9L259.4 73.9H257.4L260.5 77.2L272.3 89.8C272.9 89.4 273.5 88.9 274.1 88.5L264.1 77.9Z",
    fill: "#6BE42C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M247.3 61.5L236.8 51.7L203.3 20.5C202.9 21.1 202.4 21.7 202 22.3L238.9 56.6L249.1 63.9C248.4 63.1 247.8 62.3 247.3 61.5Z",
    fill: "#6BE42C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M266.8 77.3L261.4 73.9H261.3H259.3L264 77.9L275.3 87.4C275.9 86.9 276.4 86.4 276.9 85.9L266.8 77.3Z",
    fill: "#79E826"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M249.1 63.9L238.9 56.6L198.8 28C198.5 28.7 198.2 29.3 197.9 30L240.7 60.5L251.4 66.1C250.5 65.4 249.8 64.7 249.1 63.9Z",
    fill: "#79E826"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M251.3 66.1L240.6 60.5L195.5 36.7C195.3 37.4 195.1 38.1 195 38.9L240.4 62.8L253.3 67.7C252.6 67.2 251.9 66.7 251.3 66.1Z",
    fill: "#86EC20"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M270.4 77L263.5 73.9H263.4H261.3H261.4L266.8 77.3L278.5 84.6C279 84.1 279.5 83.5 280 83L270.4 77Z",
    fill: "#86EC20"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M275 76.7L265.4 73.9H265.3H263.5H263.6L270.5 77L281.2 81.8C281.7 81.2 282.2 80.6 282.6 80.1L275 76.7Z",
    fill: "#93F019"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M253.3 67.7L240.4 62.8L194 45.3C193.9 46.1 193.9 46.8 193.9 47.6L241.7 65.6L242.5 65.9L256.1 69.3C255.1 68.9 254.2 68.3 253.3 67.7Z",
    fill: "#93F019"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M278.4 75.4L268.6 74.1L267.3 73.9H267.1H265.4H265.5L275.1 76.7L283.4 79.1C283.9 78.5 284.3 77.9 284.7 77.2L278.4 75.4Z",
    fill: "#A1F313"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M256 69.3L242.5 66L241.7 65.8L194 53.9C194.1 54.7 194.1 55.4 194.3 56.2L241.4 67.9L258.8 70.5C257.8 70.2 256.9 69.8 256 69.3Z",
    fill: "#A1F313"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M258.7 70.5L241.3 67.9L195.2 61.1C195.4 61.9 195.6 62.6 195.8 63.4L236.8 69.4L260.9 71.1C260.2 70.9 259.4 70.7 258.7 70.5Z",
    fill: "#AEF70D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M269.9 73.9H269.4H266.9H267.1L268.4 74.1L278.2 75.4L285 76.3C285.3 75.9 285.5 75.5 285.8 75.1L269.9 73.9Z",
    fill: "#AEF70D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M286.6 73.9H269.4H269.9L285.9 75C286.1 74.7 286.2 74.5 286.4 74.2C286.5 74.1 286.5 74 286.6 73.9Z",
    fill: "#BCFB06"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M266 71.7C264.3 71.7 262.6 71.5 261 71.1L236.9 69.4L196.9 66.6C197.2 67.4 197.5 68.1 197.8 68.8L238.1 71.6L266 71.7Z",
    fill: "#BCFB06"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M238.1 71.7H199.1C199.5 72.4 199.9 73.2 200.3 73.9H286.7C286.7 73.8 286.8 73.7 286.8 73.6C286.9 73.4 287.1 73.1 287.2 72.9C287.4 72.5 287.6 72.1 287.8 71.7H238.1Z",
    fill: "#C8FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLookoutLogo);
export default __webpack_public_path__ + "static/media/lookout-logo.f5085f03f727f4465fc8eb6036364409.svg";
export { ForwardRef as ReactComponent };